import { render, staticRenderFns } from "./UpdateProfileRequestViewInfo.vue?vue&type=template&id=d25e4dd0&"
import script from "./UpdateProfileRequestViewInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileRequestViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports